import { Stack } from '@mui/material'
import { ProgressBar } from 'settle-ui/components/ProgressBar/ProgressBar'
import { useOnboardingLayoutContext } from '../../hooks/useOnboardingLayoutContext/useOnboardingLayoutContext'
import { OnboardingStepper } from './components/OnboardingStepper/OnboardingStepper'
import {
  OnboardingProgressBar,
  type OnboardingProgressBarProps,
} from './components/OnboardingProgressBar/OnboardingProgressBar'
import { OnboardingBanners } from './components/OnboardingBanners/OnboardingBanners'

export interface OnboardingTopSectionProps extends Pick<OnboardingProgressBarProps, 'businessType'> {
  withProgressBar?: boolean
  progress?: number
  visibility: 'mobile' | 'desktop'
}

export const OnboardingTopSection: Settle.FC<OnboardingTopSectionProps> = ({
  businessType,
  withProgressBar,
  visibility,
  progress,
  ...props
}) => {
  const { flowType } = useOnboardingLayoutContext()

  return (
    <Stack
      sx={{
        ...(visibility === 'mobile'
          ? { display: { xs: 'flex', mobile: 'none' }, width: '100%' }
          : { display: { xs: 'none', mobile: 'flex' }, mx: 'auto' }),
      }}
      {...props}
    >
      {withProgressBar &&
        (progress !== undefined ? (
          <ProgressBar value={progress} variant="determinate" />
        ) : (
          <OnboardingProgressBar businessType={businessType} />
        ))}
      {flowType && <OnboardingStepper />}
      <OnboardingBanners />
    </Stack>
  )
}
